/**
 * Follow Up Modal Component
 */

import { FollowUpActionLabels } from '@/types/quotes-orders.types';
import { DatePicker, Form, Input, Modal, Select } from 'antd';
import React from 'react';

interface FollowUpModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (formData: any) => void;
  isLoading?: boolean;
}

export const FollowUpModal: React.FC<FollowUpModalProps> = ({
  open,
  onClose,
  onConfirm,
  isLoading = false,
}) => {
  const [form] = Form.useForm();

  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      onConfirm(values);
      form.resetFields();
    } catch (error) {
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title="Quote Follow-up"
      open={open}
      onCancel={handleCancel}
      onOk={handleConfirm}
      okText="Confirm"
      cancelText="Cancel"
      confirmLoading={isLoading}
      width={600}
    >
      <p className="text-gray-600 mb-4">
        Set follow-up details for this quote
      </p>

      <Form form={form} layout="vertical">
        <Form.Item
          label="Follow-up Type"
          name="followUpType"
          rules={[{ required: true, message: 'Please select follow-up type' }]}
        >
          <Select placeholder="Select follow-up type">
            {Object.entries(FollowUpActionLabels).map(([value, label]) => (
              <Select.Option key={value} value={value}>
                {label}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          label="Follow-up Date"
          name="followUpDate"
          rules={[{ required: true, message: 'Please select follow-up date' }]}
        >
          <DatePicker
            format="DD/MM/YYYY"
            className="w-full"
            placeholder="Select date"
          />
        </Form.Item>

        <Form.Item
          label="Remarks/Notes"
          name="remarks"
        >
          <Input.TextArea
            rows={4}
            placeholder="Enter any remarks or notes"
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default FollowUpModal;
